import tableModule from './modules/table';

const state = {
  ...tableModule.state,
  conceptPaymentTypes: [],
  serviceName: 'concept_payment_types',
};

const getters = {
  ...tableModule.getters,
};

const actions = {
  ...tableModule.actions,

  fetchConceptPaymentTypes(context) {
    return this.$services
      .resource('concept_payment_types')
      .get()
      .then((res) => res.data.data.conceptPaymentTypes)
      .then((conceptPaymentTypes) => context.commit('SET_CONCEPT_PAYMENT_TYPES', conceptPaymentTypes));
  },
};

const mutations = {
  ...tableModule.mutations,
  SET_CONCEPT_PAYMENT_TYPES(state, conceptPaymentTypes) {
    state.conceptPaymentTypes = conceptPaymentTypes;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
